import React, { Component } from 'react';
import { Home } from './components/Home';

export default class App extends Component {
  displayName = App.name;

  render() {
    return (
      <Home />
      /* <Row>
        <Col span={12} offset={6}><Home/></Col>
      </Row> */

      /* <Layout>
        <Route exact path='/' component={Home} />
        <Route path='/counter' component={Counter} />
        <Route path='/fetchdata' component={FetchData} />
      </Layout> */
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js